import { useShallow } from 'zustand/react/shallow';

import { LmmTijdstipLabel } from '@/apps/lmm/types/LmmVoorraad';

import useLmmStore from '../useLmmStore';

export const useLmmSidepanelState = () =>
  useLmmStore(
    useShallow((state) => ({
      show: state.sidepanel.show,
      view: state.sidepanel.view,
      lmmVoorraad: state.sidepanel.lmmVoorraad,
      lmmTijdstip: state.sidepanel.lmmTijdstip,
      geselecteerdeDefect: state.sidepanel.geselecteerdeDefect,
      kanTerugNaarVoorraad: !!state.sidepanel.vorigeLmmVoorraad,
    })),
  );
export const useLmmSidepanelShow = () => useLmmStore((state) => state.sidepanel.show);
export const useLmmSidepanelMaterieel = () => useLmmStore((state) => state.sidepanel.lmmVoorraad?.materieel);
export const useIsLmmSidepanelSelected = (materieel: string, label: LmmTijdstipLabel) =>
  useLmmStore(
    (state) => state.sidepanel.lmmVoorraad?.materieel === materieel && state.sidepanel.lmmTijdstip?.label === label,
  );
export const useSetSidepanelLmmVoorraad = () => useLmmStore((state) => state.setSidepanelLmmVoorraad);
export const useSetSidepanelLmmMaterieel = () => useLmmStore((state) => state.setSidepanelLmmMaterieel);
export const useRestoreSidepanelLmmVoorraad = () => useLmmStore((state) => state.restoreSidepanelLmmVoorraad);
export const useCloseLmmSidepanel = () => useLmmStore((state) => state.closeSidepanel);
